export class Clinic {

    clinicID: number;
    clinicName: string;
    clinicShortName: string;
    address1: string;
    address2: string;
    phone: string;
    phoneExtension: string;
    addressZipCode: string;
    locationX: number;
    locationY: number;
    state: string;
    idSalud: number;
    openClosed: string;
    municipalityID: number;
    municipality: {
        municipalityID: number;
        municipalityName: string;
    };
    regionID: number;
    region: {
        regionID: number;
        regionName: string;
    };
    addressFull: string;
    estadoFila: number;
    flag:boolean;
    selectedMotivo;

    constructor() {
        this.selectedMotivo = 0;
    }

}
